'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M28 171.5l121.8 121.9 5.8 5.8-1.3 8-26.8 170.2c53.6-27.3 107.2-54.5 160.8-81.8 0-130.2 0-260.3 0-390.5l-78.8 131.7-3.8 6.4-7.4 1.2-170.2 27.1z', 'M155.5 299.1l-5.8-5.8-121.8-121.9 170.2-27.1 7.4-1.2 3.8-6.4 78.8-131.7 0 390.5-160.8 81.8 26.8-170.2 1.3-8zM8.5 174.6l129.9 130.1-28.6 181.6-3.1 19.5 17.6-9 179.9-91.5c0-777.2 0-290.1 0-458.1l-16 26.7-92.6 154.7-181.6 28.9-19.5 3.1 14 14z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;